// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { CtiRequests } from '../constants/cti.constants';
import { CtiChatRequest } from './cti-chat-request';

export class CtiDialogCollectionCancelRequest extends CtiChatRequest{
    messageName: string = CtiRequests.ChatDialogSecureCollectionCancel;
    requestId: string;
    public constructor(uui: string, sessionId: string, requestId: string){
      super(uui, sessionId);
      this.requestId = requestId;
    }
}
